import authAxios, { authHeader } from "../data";

const fetchSingle = async (userId: string | null) => {
  const result = await authAxios.get(`/api/payment-providers/customers/${userId}`, {
    headers: authHeader()
  });

  return result.data;
};

const PaymentProviderCustomersService = {
  fetchSingle
};

export default PaymentProviderCustomersService;
